var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/employee-details.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<ul class=\"c-list\">\n\n    ";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup(((lineno = 2, colno = 35, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"employee")),"name");
frame.set("employeeName", t_1, true);
if(frame.topLevel) {
context.setVariable("employeeName", t_1);
}
if(frame.topLevel) {
context.addExport("employeeName", t_1);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "employeeName")) {
output += "\n\n        <li class=\"c-list__li c-profile__name\">\n\n            <label class=\"c-list__label\">\n                ";
output += runtime.suppressValue((lineno = 9, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-relative-name",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </label>\n\n            <span class=\"c-list__value\">\n                ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "employeeName"), env.opts.autoescape);
output += "\n            </span>\n\n        </li>\n\n    ";
;
}
output += "\n\n    <li class=\"c-list__li c-profile__employee-id\">\n\n        <label class=\"c-list__label\">\n            ";
output += runtime.suppressValue((lineno = 23, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-relative-employee-id",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n        </label>\n\n        <span class=\"c-list__value\">\n            ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 27, colno = 23, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["profile"]))),"employee")),"employeeId"), env.opts.autoescape);
output += "\n        </span>\n\n    </li>\n\n</ul>\n\n<div class=\"c-profile__employee-barcode\">\n\n    <img src=\"";
output += runtime.suppressValue((lineno = 36, colno = 25, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["employeeBarcode"])), env.opts.autoescape);
output += "\" class=\"c-profile__barcode-image\" />\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/employee-details.j2"] , dependencies)